export default {
    USER_TYPE: 'userType',
    HAS_VEHICLE_IN_GARAGE: 'hasVehicleInGarage',
};



// WEBPACK FOOTER //
// ./src/constants/dataLayerVariables.js